export default __webpack_public_path__ + "static/media/DisneyMickeyMouse.d3ac6f31.jpg";